<div class="profile-image-uploader">
  <div class="profile-image-uploader__image">
    @if (isLoadingImage()) {
      <div class="profile-image-uploader__placeholder">
        <cm-spinner [loading]="true" size="small" />
      </div>
    } @else if (imageUrl()) {
      <img [src]="imageUrl()" [alt]="imageAlt()" class="profile-image-uploader__photo" />
    } @else {
      <cm-avatar
        [fullName]="userName()"
        [alt]="imageAlt()"
        size="lg"
        colorScheme="avatar--blueberry"
      />
    }
  </div>

  <div class="profile-image-uploader__controls">
    <p class="profile-image-uploader__title">Profile Picture</p>
    <p class="profile-image-uploader__hint">
      Upload a square image (PNG or JPG, max 5 MB). If no picture is uploaded, your initials are
      displayed.
    </p>
    <cm-button
      variant="stroked"
      color="primary"
      size="sm"
      autId="profile-image-upload-button"
      (click)="openUploadDialog()"
    >
      Upload photo
    </cm-button>
  </div>
</div>
